var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer d-flex justify-content-between align-items-center"},[_vm._v("\n  © Copyright 2021-2022 AGCADDY Inventory V1.6\n  "),_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("Last Update: "+_vm._s(_vm.dateTimeFormat(_vm.lastUpdate)))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bd4217d4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/footer_view.vue
// module id = 1391
// module chunks = 3